// import React, { useEffect, useState } from "react";
// import { Award, Users, Clock, Heart } from "lucide-react";

function About() {
  // const stats = [
  //   { icon: Users, label: "Clients Served", value: "500+" },
  //   { icon: Clock, label: "Years Experience", value: "3+" },
  //   { icon: Award, label: "Certifications", value: "6" },
  //   { icon: Heart, label: "Success Rate", value: "95%" },
  // ];

  return (
    <section id="about" className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* <div className="text-center mb-16"> */}
        <div className="text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            About Srilatha Rakesh
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Certified Life Coach dedicated to helping individuals discover their
            true potential and create meaningful change in their lives.
          </p>
        </div>

        {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <img
              src="https://images.pexels.com/photos/3184338/pexels-photo-3184338.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Srilatha Rakesh"
              className="rounded-2xl shadow-lg w-full"
            />
          </div>
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">My Story</h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              After spending 15 years in corporate marketing, I discovered that
              my true passion was helping others unlock their potential. I've
              been where you are - feeling stuck, overwhelmed, and uncertain
              about the next steps in life.
            </p>
            <p className="text-gray-600 mb-8 leading-relaxed">
              Through my own transformation journey, I learned powerful tools
              and strategies that I now share with my clients. I believe that
              everyone has the capacity for extraordinary growth and fulfillment
              - sometimes we just need the right guidance to get there.
            </p>

            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className="text-center p-4 bg-purple-50 rounded-lg"
                >
                  <stat.icon className="h-8 w-8 text-purple-600 mx-auto mb-2" />
                  <div className="text-2xl font-bold text-gray-900">
                    {stat.value}
                  </div>
                  <div className="text-sm text-gray-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
}

export default About;
